<template>
	<el-container class="hone-container">
		<!-- 页面头部区域 -->
		<el-header class="header">
			<div class="header-left">
				<img class="img" src="../assets/image/logo.png" alt="" />
				<span class="headerTitle">安徽智联科技</span>
				<div class="toggle-button-container">
					<div id="toggle-button-close"
						:class="[isActive ? toggleButtonClose : toggleButtonOpen]" @click="toggleCollapse"></div>
				</div>
			</div>
			<div class="right-header">
				<div>
	<img v-if="!isFullscreen" 
	class="fullscreen-icon header-icon-btn" 
	@click="toggleFullScreen()"
	src="../../../smart-lock-project-web-admin/src/assets/image/quanping.png" 
	alt="全屏" 
	title="全屏"/>
<img v-if="isFullscreen" 
	class="fullscreen-icon header-icon-btn" 
	@click="toggleFullScreen()"
	src="../../../smart-lock-project-web-admin/src/assets/image/tuichuquanping.png" 
	alt="退出全屏" 
	title="退出全屏"/>
					<el-dropdown trigger="click" @command="handleCommand">
						<img style="width:40px; height:40px;border-radius: 7.5px;" src="../assets/image/head.png" />
						<i class="el-icon-caret-bottom" style="margin-top: 30px;"></i>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="1">个人账号</el-dropdown-item>
							<el-dropdown-item command="2" divided>退出登录</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</div>
		</el-header>
		<!-- 页面主体区域 -->
		<el-container>
			<!-- 侧边栏 -->
			<el-aside :width="isCollpase ? '50px' : '200px'" id="el-aside">
				<!-- 侧边栏菜单区域  unique-opened为true 则默认只打开一个菜单栏 collapse-transition 是否开启菜单折叠动画效果 默认是开启 
					router 开启路由模式 路由的地址为 index的值
				-->
				<el-scrollbar style="height:100%;width: 100%; overflow-x: hidden;">
					<el-menu background-color="#FFFFFF" text-color="#595959" active-text-color="#3CA757"
						:unique-opened="true" :collapse="isCollpase" :collapse-transition="false" router
						:default-active="activePath">
						<!-- 首页 -->
						<el-menu-item :index="'/welcome'" @click="saveNavState('/welcome')">
							<!-- 图标 -->
							<i class="el-icon-s-home">&nbsp;</i>
							<!-- 文本 -->
							<span class="text-size">首页</span>
						</el-menu-item>
						<!-- 一级菜单 -->
						<el-submenu v-for="item in menulist" :key="item.id" :index="item.id + ''">
							<!-- 一级菜单的模板区 -->
							<template slot="title">
								<!-- 图标 -->
								<i :class="item.menuIcon">&nbsp;</i>
								<!-- 文本 -->
								<span class="text-size">{{ item.menuName }}</span>
							</template>
							<!-- 二级菜单模板区 -->
							<el-menu-item v-for="subItem in item.subMenus" :key="subItem.id"
								:index="'/' + subItem.menuUrl" @click="saveNavState('/' + subItem.menuUrl)">
								<template slot="title">
									<!-- 图标 -->
									<!-- <i class="el-icon-menu text-size"></i> -->
									<!-- 文本 -->
									<span class="text-size">&nbsp;&nbsp;&nbsp;{{ subItem.menuName }}</span>
								</template>
							</el-menu-item>
						</el-submenu>
					</el-menu>
				</el-scrollbar>
			</el-aside>
			<!-- 主体区域 -->
			<el-main id="el-main">
				<div class="father">
					<transition name="fade" mode="out-in">
						<router-view :key="$route.fullPath" v-if="show" class="main"></router-view>
					</transition>
				</div>
			</el-main>
		</el-container>
	</el-container>
</template>

<script>
import screenfull from "screenfull";

export default {
	data() {
		return {
			show: true,
			isFullscreen: false,
			menulist: [],
			isCollpase: false,
			//被激活的链接地址
			activePath: '',
			toggleButtonClose: 'toggle-button-close el-icon-s-fold',
			toggleButtonOpen: 'toggle-button-close el-icon-s-unfold',
			isActive: true,
			nickName: '',
			elIconIHome: 'el-icon-s-home'
		}
	},
	mounted() {
		window.addEventListener('keydown', (event) => this.handleKeyDown(event));
		// 监听screenfull的change事件
		screenfull.on('change', () => {
			this.isFullscreen = screenfull.isFullscreen;
			if (this.isFullscreen) {
				// 在全屏状态下，手动添加Esc键的事件处理
				document.addEventListener('keydown', this.handleFullscreenEscKeyDown);
			} else {
				// 退出全屏后，移除手动添加的Esc键事件处理
				document.removeEventListener('keydown', this.handleFullscreenEscKeyDown);
			}
		});
	},
	beforeDestroy() {
		// 组件销毁前移除事件监听
		window.removeEventListener('keydown', this.handleKeyDown);
		// 移除screenfull的change事件监听
		screenfull.off('change');
	},
	created() {
		this.getMenuList()
		// 修复刷新页面路由跳转问题：优先使用当前路由作为activePath
		const currentPath = this.$route.path
		if (currentPath && currentPath !== '/home' && currentPath !== '/welcome') {
			this.activePath = currentPath
			window.sessionStorage.setItem('activePath', currentPath)
		} else {
			// 如果是首页，则从sessionStorage获取
			const storedPath = window.sessionStorage.getItem('activePath')
			this.activePath = storedPath || '/welcome'
		}
		this.nickName = 'admin管理员'
	},

	methods: {
		handleKeyDown(event) {
			if (event.key === 'Escape') {
				// 这里编写按下Esc键后的逻辑
				this.isFullscreen = false;
			}
		},
		logout() {
			window.sessionStorage.clear()
			this.$router.push('/login')
		},
		//获取菜单列表
		async getMenuList() {
			const {
				data: res
			} = await this.$http.get('/system/authorities/menus')
			this.menulist = res.data
		},
		//点击按钮 切换菜单的折叠与展开
		toggleCollapse() {
			if (this.isCollpase) {
				this.isActive = true
				this.isCollpase = false
			} else {
				this.isActive = false
				this.isCollpase = true
			}
		},
		//保存菜单的激活状态
		saveNavState(activePath) {
			window.sessionStorage.setItem('activePath', activePath)
			this.activePath = activePath
		},
		toBigScreen() {
			this.$router.push('/signin')
		},
		handleCommand(command) {
			if (command === '1') {
				this.$router.push('/my/myInfo')
			} else if (command === '2') {
				this.logout()
			}
		},
		toggleFullScreen() {
			if (screenfull.isEnabled) {
				screenfull.toggle();
				this.isFullscreen = !this.isFullscreen;
			}
		},
		handleFullscreenEscKeyDown(event) {
			if (event.key === 'Escape') {
				// 这里是全屏状态下按下Esc键的处理逻辑
				this.isFullscreen = false;
			}
		}
	},
}
</script>

<style scoped>
.el-header {
	background-color: #3CA757;
	display: flex;
	justify-content: space-between;
	padding-left: 0;
	align-items: center;
	color: #fff;
	font-size: 1.25rem;
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	z-index: 1000;
	height: 50px !important;
}

.el-header div {
	display: flex;
	align-items: center;
	margin-left: 1rem;
}

.el-header div span {
	margin-left: 0.9375rem;
}

.el-aside {
	background-color: #F0F2F5;
	position: fixed;
	top: 50px;
	left: 0;
	bottom: 0;
	z-index: 999;
	overflow-y: auto;
	overflow-x: hidden;
}

.el-aside .el-menu {
	/* 设置侧边栏展开时 右边不会突出 */
	border-right: none;
}

.el-main {
	background-color: #F0F2F5;
	padding: 20px;
	margin-left: 200px;
	margin-top: 50px;
	overflow-y: auto;
	height: calc(100vh - 50px);
	transition: margin-left 0.3s ease;
}

.hone-container {
	height: 100vh;
	overflow: hidden;
}

.img{
	border-radius: 50%;
}
.el-header img {
	height: 2.5rem;
	width: 2.5rem;
}

.toggle-button-container {
	display: flex;
	align-items: center;
	margin-left: 0.5rem;
}

.toggle-button-close {
	font-size: 20px;
	color: #fff;
	text-align: center;
	height: 36px;
	width: 36px;
	line-height: 36px;
	cursor: pointer;
	transition: all 0.3s ease;
	border-radius: 4px;
}

.text-size {
	font-size: 95%;
}

.header {
	display: flex;
}
.right-header{
	display: flex;
}

/* 头部图标按钮统一样式 */
.header-icon-btn {
	cursor: pointer;
	margin-right: 8px;
	transition: all 0.3s ease;
	/* border-radius: 4px; */
}

/* 全屏图标特殊样式 */
.fullscreen-icon {
	height: 25px;
	width: 25px;
	padding: 2px;
	vertical-align: middle;
	background: none;
}

/* 移除全屏图标悬停效果的背景色 */
.fullscreen-icon:hover {
	background: none !important;
	transform: none !important;
}
.el-dropdown-menu--mini .el-dropdown-menu__item {
    line-height: 28px !important;
    padding: 0 15px !important;
    font-size: 13px !important;
}

/* 其他头部图标按钮的悬停效果 */
.header-icon-btn:hover:not(.fullscreen-icon) {
	background-color: rgba(255, 255, 255, 0.1);
	transform: scale(1.05);
}

/* 侧边栏折叠时的主内容区域样式调整 */
.el-aside[style*="width: 50px"] + .el-main {
	margin-left: 50px;
}
</style>
